// Stub function middleware that would attach the user's bearer token to outgoing serverFn calls.
import { createMiddleware } from "@tanstack/react-start";
import { supabase } from "./client";

export const attachSupabaseAuth = createMiddleware({ type: "function" }).client(async ({ next }) => {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (token) {
      return next({ headers: { authorization: `Bearer ${token}` } });
    }
  } catch {
    // ignore — no session available
  }
  return next();
});